/** The TV apps add this to the event link in their "Buy on your phone" QR code. */
export const TV_CHECKOUT_PARAM = 'from';
export const TV_CHECKOUT_VALUE = 'tv';

const STORAGE_KEY = 'millions_tv_checkout_visit';

/**
 * A fan who scanned the TV's code must finish buying on the web so the TV unlocks,
 * so the visit is remembered for the tab: sign-up and checkout pages drop the query.
 */
export const isTvCheckoutVisit = (search: string): boolean => {
  const fromTv =
    new URLSearchParams(search).get(TV_CHECKOUT_PARAM) === TV_CHECKOUT_VALUE;
  try {
    if (fromTv) {
      sessionStorage.setItem(STORAGE_KEY, '1');
      return true;
    }
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (error) {
    console.warn('isTvCheckoutVisit: storage unavailable', error);
    return fromTv;
  }
};
